import React from 'react';
import GenericView, { ViewItem } from 'modules/common/components/GenericView';
import PropTypes from 'prop-types';
import { jsUcFirst } from 'modules/common/helper';

function DetailsView({ data }) {
  return (
    <GenericView
      data={data}
      trClassName="odd:bg-secondary-100"
      labelWidth="35%"
    >
      {Object.keys(data).map((k) => {
        const label = k.replace('_', ' ');
        return (
          <ViewItem
            key={k}
            name={k}
            label={jsUcFirst(label)}
            isDate={k === 'birth_date'}
          />
        );
      })}
    </GenericView>
  );
}

DetailsView.defaultProps = {};

DetailsView.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default DetailsView;
